import { render } from "./Dados.vue?vue&type=template&id=833a3eb8"
import script from "./Dados.vue?vue&type=script&lang=js"
export * from "./Dados.vue?vue&type=script&lang=js"

import "./Dados.vue?vue&type=style&index=0&id=833a3eb8&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__